import { FC, useCallback } from 'react';
import * as S from './Switch.styled';
import { SwitchProps, FinalSwitchProps, RawSwitchProps } from './Switch.types';
import { Field, FieldRenderProps } from 'react-final-form';

export const Switch: FC<SwitchProps> = ({
    checked: checkedRaw,
    onChange,
    disabled,
    labels,
    className,
    thumb,
    disabledThumb,
    inverseValue
}) => {
    const checked = inverseValue ? !checkedRaw : checkedRaw;

    const toggle = useCallback(() => {
        if (disabled) {
            return;
        }

        onChange(!checkedRaw);
    }, [disabled, onChange, checkedRaw]);

    const disable = useCallback(() => {
        if (disabled) {
            return;
        }

        onChange(inverseValue ? true : false);
    }, [disabled, onChange, inverseValue]);

    const enable = useCallback(() => {
        if (disabled) {
            return;
        }

        onChange(inverseValue ? false : true);
    }, [disabled, onChange, inverseValue]);

    return (
        <S.Container className={className}>
            <S.Label $checked={!checked} onClick={disable}>
                {labels[0]}
            </S.Label>
            <S.Switch onClick={toggle}>
                <S.Thumb type="button" $checked={checked}>
                    <S.ThumbContent $checked={!disabledThumb || checked}>
                        {thumb}
                    </S.ThumbContent>
                    {disabledThumb && (
                        <S.ThumbContent $checked={!checked}>
                            {disabledThumb}
                        </S.ThumbContent>
                    )}
                </S.Thumb>
            </S.Switch>
            <S.Label $checked={checked} onClick={enable}>
                {labels[1]}
            </S.Label>
        </S.Container>
    );
};

const SwitchFieldRender = ({
    input,
    ...props
}: FieldRenderProps<boolean> & RawSwitchProps) => {
    const onChange = useCallback(
        (checked: boolean) => {
            input.onChange(checked);
        },
        [input]
    );

    return <Switch {...props} checked={input.value} onChange={onChange} />;
};

export function FinalSwitch<T = any>({ name, ...props }: FinalSwitchProps<T>) {
    return <Field name={name} render={SwitchFieldRender} {...props} />;
}
